import { t } from "i18next";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Team } from "../../../../interfaces/team";
import { useEffect, useState } from "react";
import { getTeamOptions } from "../../../../services/team";
import { Club } from "../../../../interfaces/club";
import { getClubOptions } from "../../../../services/club";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { emptySeason, Season } from "../../../../interfaces/season";
import { getSeasonCurrent } from "../../../../services/season";
import { Athlete } from "../../../../interfaces/athlete";
import { getAthlete } from "../../../../services/athlete";
import moment from "moment";
import { PlanningEntries } from "./planning-entries";
import { getPlanningEntries, deleteBulkPlanningEntries } from "../../../../services/planning";
import { PlanningEntry } from "../../../../interfaces/planning";

interface DayDataProps {
    planningEntries: PlanningEntry[];
    day: string;
    athlete_id: number;
    onMouseEnter?: (e: any) => void;
    onMouseLeave?: () => void;
}

function DayData(props: DayDataProps) {
    const dayData: PlanningEntry[] = props.planningEntries.filter((pe: PlanningEntry) => pe.athlete_id == props.athlete_id && pe.day == props.day);

    return <div
        className={ 'planning-day-data' + (dayData.length ? ' has-data' : '') }
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
    >
        { dayData.length == 0 ? '' : dayData.length }
    </div>
}

export function TrainingPlan() {
    const [currentSeason, setCurrentSeason] = useState<Season>(emptySeason);
    const [clubOptions, setClubOptions] = useState<Club[]>([]);
    const [teamOptions, setTeamOptions] = useState<Team[]>([]);
    const [athletes, setAthletes] = useState<Athlete[]>([]);
    const [selectedClub, setSelectedClub] = useState('');
    const [selectedTeam, setSelectedTeam] = useState('');
    const [loaded, setLoaded] = useState(false);
    const [curMonth, setCurMonth] = useState(moment().format('Y-MM'));
    const [months, setMonths] = useState<string[]>([]);
    const [days, setDays] = useState<number[]>([]);
    const [currentAthleteId, setCurrentAthleteId] = useState(0);
    const [currentDay, setCurrentDay] = useState('');
    const [showPlanningEntries, setShowPlanningEntries] = useState(false);
    const [planningEntries, setPlanningEntries] = useState<PlanningEntry[]>([]);
    const [selectionMode, setSelectionMode] = useState(false);
    const [selectedDays, setSelectedDays] = useState<{athlete_id: number, day: string}[]>([]);
    const [feedbackMessage, setFeedbackMessage] = useState<{text: string, type: 'success' | 'error'} | null>(null);
    const [hoveredDay, setHoveredDay] = useState<{athlete_id: number, day: string, x: number, y: number} | null>(null);

    useEffect(() => {
        getSeasonCurrent()
            .then(responseSeason => {
                setCurrentSeason(responseSeason.data);
                
                const start = moment(responseSeason.data.date_start);
                const end = moment(responseSeason.data.date_end);
                const newMonths: string[] = [];
                const current = start.clone().startOf('month');
                while (current.isSameOrBefore(end, 'month')) {
                    newMonths.push(current.format('YYYY-MM'));
                    current.add(1, 'month');
                }
                setMonths(newMonths);
                
                getClubOptions()
                    .then(responseClubs => {
                        setClubOptions(responseClubs.data);
                        setLoaded(true);
                    })
                    .catch(error => {
                        console.log(error);
                    });                    
            });

        /*getTeamOptions()
            .then(response => {
                setTeamOptions(response.data);
            })
            .catch(error => {
                console.log(error);
            });*/
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();
        getAthlete('', selectedClub, selectedTeam, currentSeason.id.toString(), 'display_name', 'ASC', 1, 1000)
            .then(response => {
                setAthletes(response.data);
            });
        
        const start = moment(curMonth + '-01').startOf('month');
        const end = moment(curMonth + '-01').endOf('month');
        const daysDiff = Math.round(moment.duration(end.diff(start)).asDays());
        const newDays = [];
        for (let i = 1; i <= daysDiff; i++) {
            newDays.push(i);
        }
        setDays(newDays);

        getPlanningEntries(0, start.format('YYYY-MM-DD'), start.endOf('month').format('YYYY-MM-DD'))
            .then(response => {
                setPlanningEntries(response.data);
            })
    }

    const handleClubChange = (event: any) => {
        setSelectedClub(event.currentTarget.value);
        if (event.currentTarget.value == 0) {
            setTeamOptions([]);
        } else {
            getTeamOptions(event.currentTarget.value, currentSeason.id.toString())
                .then(response => {
                    setTeamOptions(response.data);
                });
        }
    }

    const handleTeamChange = (event: any) => {
        setSelectedTeam(event.currentTarget.value);
    }

    const handleMonthChange = (event: any) => {
        const newCurMonth = event.currentTarget.dataset.month;
        setCurMonth(newCurMonth);

        const start = moment(newCurMonth + '-01').startOf('month');
        const end = moment(newCurMonth + '-01').endOf('month');
        const daysDiff = Math.round(moment.duration(end.diff(start)).asDays());
        const newDays = [];
        for (let i = 1; i <= daysDiff; i++) {
            newDays.push(i);
        }
        setDays(newDays);
        
        getPlanningEntries(0, start.format('YYYY-MM-DD'), start.endOf('month').format('YYYY-MM-DD'))
            .then(response => {
                setPlanningEntries(response.data);
            });
    }

    const handleShowTrainings = (event: any) => {
        event.preventDefault();
        const athlete_id = parseInt(event.currentTarget.dataset.athlete);
        const day = event.currentTarget.dataset.day;

        if (selectionMode) {
            // En modo selección, añadir/quitar día de la selección
            const index = selectedDays.findIndex(sd => sd.athlete_id === athlete_id && sd.day === day);
            if (index > -1) {
                // Ya está seleccionado, quitarlo
                setSelectedDays(selectedDays.filter((_, i) => i !== index));
            } else {
                // No está seleccionado, añadirlo
                setSelectedDays([...selectedDays, { athlete_id, day }]);
            }
        } else {
            // Modo normal, abrir modal para un solo día
            setCurrentAthleteId(athlete_id);
            setCurrentDay(day);
            setShowPlanningEntries(true);
        }
    }

    const showFeedback = (text: string, type: 'success' | 'error') => {
        setFeedbackMessage({ text, type });
        setTimeout(() => {
            setFeedbackMessage(null);
        }, 5000); // Se desvanece después de 5 segundos
    }

    const handleToggleSelectionMode = () => {
        setSelectionMode(!selectionMode);
        if (!selectionMode) {
            // Al activar modo selección, limpiar selección previa
            setSelectedDays([]);
        }
        // Limpiar mensaje de feedback al cambiar de modo
        setFeedbackMessage(null);
    }

    const handleClearSelection = () => {
        setSelectedDays([]);
    }

    const handleBulkEdit = () => {
        if (selectedDays.length === 0) return;

        // Para edición masiva, usamos el primer atleta y día seleccionado
        // pero pasaremos todos los días seleccionados al modal
        setCurrentAthleteId(selectedDays[0].athlete_id);
        setCurrentDay(selectedDays[0].day);
        setShowPlanningEntries(true);
    }

    const handleBulkDelete = () => {
        if (selectedDays.length === 0) return;

        const confirmMessage = t("Are you sure you want to delete all training entries from the selected days?") +
            ` (${selectedDays.length} ${t("days selected")})`;

        if (!window.confirm(confirmMessage)) return;

        deleteBulkPlanningEntries(selectedDays)
            .then((response: any) => {
                if (response.data.status == 1) {
                    const deletedCount = response.data.deleted_count || 0;
                    showFeedback(t("Entries deleted successfully") + ` (${deletedCount} ${t("entries")})`, 'success');
                    // Limpiar la selección
                    setSelectedDays([]);
                    // Refrescar los datos
                    const start = moment(curMonth + '-01');
                    getPlanningEntries(0, start.format('YYYY-MM-DD'), start.endOf('month').format('YYYY-MM-DD'))
                        .then(response => {
                            setPlanningEntries(response.data);
                        });
                } else {
                    showFeedback(response.data.message || t("Some entries could not be deleted"), 'error');
                }
            })
            .catch((error: any) => {
                console.log(error);
                showFeedback(t("Error deleting entries"), 'error');
            });
    }

    const handlePlanningEntriesSave = () => {

    }

    const handlePlanningEntriesClose = (success?: boolean, count?: number) => {
        setShowPlanningEntries(false);
        setCurrentAthleteId(0);
        setCurrentDay('');

        // Si se crearon entradas masivamente con éxito, mostrar mensaje
        if (success && selectedDays.length > 0) {
            showFeedback(t("Entries created successfully for all selected days") + ` (${count || selectedDays.length} ${t("days")})`, 'success');
        }

        setSelectedDays([]);
        const start = moment(curMonth + '-01');
        getPlanningEntries(0, start.format('YYYY-MM-DD'), start.endOf('month').format('YYYY-MM-DD'))
            .then(response => {
                setPlanningEntries(response.data);
            });
    }

    const isDaySelected = (athlete_id: number, day: string): boolean => {
        return selectedDays.some(sd => sd.athlete_id === athlete_id && sd.day === day);
    }

    const handleDayHeaderClick = (event: any) => {
        if (!selectionMode) return;

        event.preventDefault();
        const dayNum = parseInt(event.currentTarget.dataset.day);
        const dayString = curMonth + '-' + dayNum.toString().padStart(2, '0');

        // Verificar cuántos atletas de este día ya están seleccionados
        const athletesInDay = athletes.map(a => {
            const athleteIdNum = typeof a.id === 'string' ? parseInt(a.id) : a.id;
            return { athlete_id: athleteIdNum, day: dayString };
        });

        const selectedInDay = athletesInDay.filter(ad =>
            selectedDays.some(sd => sd.athlete_id === ad.athlete_id && sd.day === ad.day)
        );

        // Si todos están seleccionados, deseleccionar todos; si no, seleccionar todos
        if (selectedInDay.length === athletes.length) {
            // Deseleccionar todos los atletas de este día
            setSelectedDays(selectedDays.filter(sd => sd.day !== dayString));
        } else {
            // Seleccionar todos los atletas de este día que no estén ya seleccionados
            const newSelections = athletesInDay.filter(ad =>
                !selectedDays.some(sd => sd.athlete_id === ad.athlete_id && sd.day === ad.day)
            );
            setSelectedDays([...selectedDays, ...newSelections]);
        }
    }

    const isFullDaySelected = (dayNum: number): boolean => {
        if (!selectionMode || athletes.length === 0) return false;

        const dayString = curMonth + '-' + dayNum.toString().padStart(2, '0');
        const selectedInDay = athletes.filter(a => {
            const athleteIdNum = typeof a.id === 'string' ? parseInt(a.id) : a.id;
            return selectedDays.some(sd => sd.athlete_id === athleteIdNum && sd.day === dayString);
        });

        return selectedInDay.length === athletes.length;
    }

    const handleDayMouseEnter = (athlete_id: number, day: string, event: any) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setHoveredDay({
            athlete_id,
            day,
            x: rect.left + rect.width / 2,
            y: rect.top
        });
    }

    const handleDayMouseLeave = () => {
        setHoveredDay(null);
    }

    const getTooltipEntries = (): PlanningEntry[] => {
        if (!hoveredDay) return [];
        return planningEntries.filter((pe: PlanningEntry) =>
            pe.athlete_id == hoveredDay.athlete_id && pe.day === hoveredDay.day
        );
    }

    const truncateText = (text: string, maxLength: number = 50): string => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    }

    return (
        <div className="training-plan-container">
            <h1>
                { t('Planning')}
            </h1>
            { !loaded && <LoadingSpinner /> }
            {loaded &&
                <div className="filters-container">
                    <Form onSubmit={ handleSearchSubmit }>
                        <Form.Group className="field-club" controlId="club">
                            <Form.Select aria-label={ t("club") } name="club" onChange={ handleClubChange } required>
                                <option value="0">{ t("select_club") }</option>
                                { clubOptions.map((c: Club) => {
                                    return <option key={ 'club-' + c.id }
                                        value={ c.id }>{ c.name }</option>
                                })}
                            </Form.Select>
                        </Form.Group>
                        { teamOptions.length > 0 &&
                            <Form.Group className="field-team" controlId="team">
                                <Form.Select aria-label={ t("team") } name="team" onChange={ handleTeamChange }>
                                    <option value="0">{ t("select_team") }</option>
                                    { teamOptions.map((t: Team) => {
                                        return <option key={ 'team-' + t.id }
                                            value={ t.id }>{ t.name }</option>
                                    })}
                                </Form.Select>
                            </Form.Group>
                        }
                        <div className="actions">
                            <Button variant="primary" type="submit">
                                { t("search") }
                            </Button>
                        </div>
                    </Form>
                </div>
            }
            {loaded && athletes.length > 0 &&
                <div className="selection-controls">
                    <Button
                        variant={selectionMode ? "primary" : "outline-primary"}
                        onClick={handleToggleSelectionMode}
                        size="sm"
                    >
                        <i className={selectionMode ? "bi bi-check-square" : "bi bi-square"}></i>
                        {" "}{selectionMode ? t("Exit selection mode") : t("Selection mode")}
                    </Button>
                    {selectionMode && selectedDays.length > 0 && (
                        <>
                            <span className="selected-count">
                                {selectedDays.length} {t("days selected")}
                            </span>
                            <Button
                                variant="success"
                                onClick={handleBulkEdit}
                                size="sm"
                            >
                                <i className="bi bi-plus-circle"></i> {t("Add to selected days")}
                            </Button>
                            <Button
                                variant="danger"
                                onClick={handleBulkDelete}
                                size="sm"
                            >
                                <i className="bi bi-trash"></i> {t("Delete from selected days")}
                            </Button>
                            <Button
                                variant="outline-secondary"
                                onClick={handleClearSelection}
                                size="sm"
                            >
                                <i className="bi bi-x-circle"></i> {t("Clear selection")}
                            </Button>
                        </>
                    )}
                </div>
            }
            {feedbackMessage && (
                <div className={`feedback-toast ${feedbackMessage.type}`}>
                    <i className={`bi ${feedbackMessage.type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'}`}></i>
                    {" "}{feedbackMessage.text}
                </div>
            )}
            {hoveredDay && getTooltipEntries().length > 0 && (
                <div
                    className="planning-tooltip"
                    style={{
                        left: hoveredDay.x,
                        top: hoveredDay.y
                    }}
                >
                    <div className="tooltip-content">
                        {getTooltipEntries().map((entry: PlanningEntry, index: number) => (
                            <div key={`tooltip-entry-${entry.id}`} className="tooltip-entry">
                                <span className="tooltip-color" style={{ backgroundColor: entry.color }}></span>
                                <span className="tooltip-session">S{entry.session}:</span>
                                <span className="tooltip-description">{truncateText(entry.description)}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {loaded &&
                <div className="grid-container">
                    <Row>
                        <Col>
                            {athletes.length > 0 &&
                                <div className="planning-container">
                                    <div className="months-index">
                                        { months.map((m: string) => {
                                            return <div key={'month-' + m} className={ 'month-intex-item' + (m == curMonth ? ' active' : '') } data-month={ m } onClick={ handleMonthChange }>
                                                    { moment(m + '-01').format('MMM Y') }
                                                </div>
                                        })}
                                    </div>
                                    <div className="months-calendar">
                                        <div className="athletes">
                                            <div className="athlete-heading">
                                                { t("Athletes")}
                                            </div>
                                            { athletes.map((a: Athlete) => {
                                                return <div key={'athlete-name-' + a.id} className="athlete-item">
                                                        { a.name }
                                                    </div>;
                                            })}
                                        </div>
                                        <div className="days">
                                            <div className="training-plan-month">
                                                { days.map((d: number) => {
                                                    const isFullDay = isFullDaySelected(d);
                                                    return <div
                                                        key={'day-header-' + d}
                                                        className={`day-item ${selectionMode ? 'selectable' : ''} ${isFullDay ? 'full-day-selected' : ''}`}
                                                        onClick={handleDayHeaderClick}
                                                        data-day={d}
                                                    >
                                                        <div className="day-num">
                                                            { d }
                                                        </div>
                                                    </div>;
                                                })}
                                            </div>
                                            { athletes.map((a: Athlete) => {
                                                return <div key={'athlete-row-' + a.id} className="athlete-item">
                                                        <div className="training-plan-month-data">
                                                            { days.map((d: number) => {
                                                                const dayString = curMonth + '-' + d.toString().padStart(2, '0');
                                                                const athleteIdNum = typeof a.id === 'string' ? parseInt(a.id) : a.id;
                                                                const isSelected = isDaySelected(athleteIdNum, dayString);
                                                                const className = isSelected ? "day-item selected" : "day-item";

                                                                return <div
                                                                        key={'day-' + a.id + '-' + d}
                                                                        className={className}
                                                                        onClick={ handleShowTrainings }
                                                                        data-athlete={ a.id }
                                                                        data-day={ dayString }
                                                                    >
                                                                        <DayData
                                                                            athlete_id={ athleteIdNum }
                                                                            day={ dayString }
                                                                            planningEntries={ planningEntries }
                                                                            onMouseEnter={(e) => handleDayMouseEnter(athleteIdNum, dayString, e)}
                                                                            onMouseLeave={handleDayMouseLeave}
                                                                        />
                                                                    </div>;
                                                            })}
                                                        </div>
                                                    </div>;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            }
            { showPlanningEntries && currentDay != '' && currentAthleteId != 0 &&
                <PlanningEntries
                    athlete_id={ currentAthleteId}
                    day={ currentDay}
                    selectedDays={ selectedDays.length > 0 ? selectedDays : undefined }
                    onSave={ handlePlanningEntriesSave }
                    onClose={ handlePlanningEntriesClose }
                />
            }
        </div>

    )
}